import { cancelExchangeOffers } from "../../../app/api/exchangeOffer";
import { BaseAction } from "../../../core/actions/BaseAction";
import { ICancelQuickExchangeAction } from "../../../Orchestrator/Types/Interface/ActionParams/SearchBookingParams";

class CancelQuickExchangeAction extends BaseAction<void, ICancelQuickExchangeAction> {
    override async run(): Promise<void> {
        try {
            if (this.params) {
                const { bookingId, exchangeOperationId } = this.params
                const response = await cancelExchangeOffers(bookingId, exchangeOperationId)
                sessionStorage.removeItem("exchangeBookingId")
                sessionStorage.removeItem("exchangeOperationId")
            }
        } catch (error: any) {
            console.error("Error fetching language:", error);
        }
    }
}

export const cancelQuickExchangeAction = new CancelQuickExchangeAction()


